<template>
  <div class="container">
    <div class="header">
      <h2 class="title">分享排行</h2>
      <div class="searchbox">
        <input type="text"
               placeholder="输入姓名或者电话"
               v-model="searchData.key"
               @input="changeData"
               class="search-input">
        <img src="../assets/img/放大镜.png"
             class="glass" />
      </div>
      <!-- 访客，日期选择 -->
      <div class="selectbox">
        <div>
          <span>{{finalVisitName}}</span>
          <i class="icon-sanjiaoxiabiao iconfont col"
             @click="changeState(1)"></i>
        </div>
        <div>
          <span>{{finalDateName}}</span>
          <i class="icon-sanjiaoxiabiao iconfont col"
             @click="changeState(2)"></i>
        </div>

      </div>
      <!-- 访客，日期选择 -->

    </div>
    <!-- 列表数据 -->
    <div v-if="listData.length<=0">
      <nodata></nodata>
    </div>
    <div class="ranklist"
         v-if="listData.length>0">
      <mt-loadmore :top-method="loadTop"
                   :bottom-method="loadBottom"
                   :bottom-all-loaded="allLoaded"
                   :auto-fill="false"
                   ref="loadmore">
        <div v-if="!Array.isArray(myData)"
             class="rankitem"
             style="background:#F4F4F4"
             @click="getDetail(myData.uuid,myData.name,myData.phone,myData.avatar,myData.bc_login_token)">
          <!-- 左侧排名&&姓名&&电话begin -->
          <div class="rankitem-left">
            <div class="ranks">{{myData.rank}}</div>
            <div class="rankitem-img">
              <img v-if="!myData.avatar"
                   src="../assets/img/user-avatar.png"
                   class="rankitem-user-avatar" />
              <img :src="getAvatar(myData.avatar)"
                   class="rankitem-user-avatar" />
            </div>
            <div>
              <div class="rankitem-name">{{myData.name}}</div>
              <div>{{myData.phone}}</div>
            </div>
          </div>
          <!-- 左侧排名&&姓名&&电话end -->
          <!-- 右侧访问量&&人数 begin-->
          <div class="rankitem-right">
            <div>
              <div>人气</div>
              <div class="rank-num">{{myData.popularity_counts}}</div>
            </div>
            <div class="border"></div>
            <div>
              <div>浏览人数</div>
              <div class="rank-num">{{myData.visitor}}</div>
            </div>
          </div>
          <!-- 右侧访问量&&人数 end-->
        </div>
        <ul>
          <li class="rankitem"
              v-for="(item,index) in listData"
              :key="index"
              @click="getDetail(item.uuid,item.name,item.phone,item.avatar,item.bc_login_token)">
            <!-- 左侧排名&&姓名&&电话begin -->
            <div class="rankitem-left">
              <div style="position:relative">
                <img src="../assets/img/no1.png"
                     class="rank-pic"
                     v-if="item.rank==1" />
                <img src="../assets/img/no2.png"
                     class="rank-pic"
                     v-if="item.rank==2" />
                <img src="../assets/img/no3.png"
                     class="rank-pic"
                     v-if="item.rank==3" />
              </div>

              <div class="ranks">{{item.rank}}</div>
              <div class="rankitem-img">
                <img v-if="!item.avatar"
                     src="../assets/img/user-avatar.png"
                     class="rankitem-user-avatar" />
                <img v-if="item.avatar"
                     :src="getAvatar(item.avatar)"
                     class="rankitem-user-avatar" />
              </div>
              <div>
                <div class="rankitem-name">{{item.name?item.name:'未知'}}</div>
                <div>{{item.phone?item.phone:'未知'}}</div>
              </div>
            </div>
            <!-- 左侧排名&&姓名&&电话end -->
            <!-- 右侧访问量&&人数 begin-->
            <div class="rankitem-right">
              <div>
                <div>人气</div>
                <div class="rank-num">{{item.popularity_counts}}</div>
              </div>
              <div class="border"></div>
              <div>
                <div>浏览人数</div>
                <div class="rank-num">{{item.visitor}}</div>
              </div>
            </div>
            <!-- 右侧访问量&&人数 end-->
          </li>
        </ul>
      </mt-loadmore>
      <div v-if="allLoaded"
           style="text-align:center">没有更多数据</div>
    </div>

    <!-- 列表数据 -->
    <!-- 底部弹窗，筛选数据begin -->
    <mt-popup v-model="PopupVisible"
              position="bottom"
              popup-transition="popup-fade"
              style="width:100%">
      <mt-picker :slots="visitList"
                 @change="onVisitChange"
                 valueKey="name"
                 v-if="isShow==1"></mt-picker>
      <mt-picker :slots="dateList"
                 @change="onDateChange"
                 valueKey="name"
                 v-if="isShow==2"></mt-picker>
      <div class="footer">
        <span @click="cancelBtn">取消</span>
        <span @click="confirmBtn"
              class="confirm">确认</span>
      </div>
    </mt-popup>
    <!-- 底部弹窗，筛选数据begin -->

  </div>
</template>
<script>
  import nodata from './public/nodata'
  import { Popup, Picker, Loadmore, InfiniteScroll, Indicator, MessageBox } from 'mint-ui';
  import Vue from 'vue';
  Vue.component(Popup.name, Popup);
  Vue.component(Picker.name, Picker);
  Vue.component(Loadmore.name, Loadmore);
  Vue.use(InfiniteScroll);
  Vue.use(Loadmore);
  export default {
    components: {
      nodata
    },
    data () {
      return {
        isShow: '',
        PopupVisible: false,
        loading: false,//加载
        //查询访问列表
        visitList: [{
          flex: 1,
          values: [{ id: 'popularity', name: '按人气' }, { id: 'visitor', name: '按浏览人数' },],
          textAlign: 'center'
        }],
        //查询日期列表
        dateList: [{
          flex: 1,
          values: [{ id: '1', name: '今日' }, { id: '7', name: '近7天' }, { id: '30', name: '近30天' }, { id: '180', name: '近半年' }],
          textAlign: 'center'
        }],
        currentIndex: '',//当前下标
        visitName: '按人气',
        dateName: '近30天',
        finalVisitName: '按人气',
        finalDateName: '近30天',
        searchData: {
          key: '',
          sort: 'popularity',//人气
          day: '30',//近30天
        },
        myData: {},//我的数据
        listData: [],//列表数据
        pagiNation: {
          total: 0,
          last_page: '',//最后一页
          current_page: '',//当前页
        },//当前页数
        totalPage: '',
        list: [],
        allLoaded: false,
      }
    },
    methods: {

      loadTop () {//下拉刷新
        this.allLoaded = false
        Indicator.open({
          text: '加载中...',
          spinnerType: 'fading-circle'
        })
        //  console.log('下拉加载')
        setTimeout(() => {
          this.getData()
          Indicator.close()
        }, 1000)
        this.$refs.loadmore.onTopLoaded();

      },
      loadBottom () {//上拉加载跟更多
        if (this.pagiNation.current_page < this.pagiNation.last_page)
          this.getList();
        this.$refs.loadmore.onBottomLoaded();
      },
      getList () {//获取更多数据
        Indicator.open({
          text: '加载中...',
          spinnerType: 'fading-circle'
        })
        if (this.pagiNation.current_page < this.pagiNation.last_page) {
          setTimeout(() => {
            this.$http.getSharkRank(this.searchData, this.pagiNation.current_page + 1).then(res => {
              this.listData = this.listData.concat(res.data.list) //列表数据
              this.myData = res.data.me//我的列表
              this.pagiNation.current_page = res.data.pagination.current_page//当前页面
              this.pagiNation.last_page = res.data.pagination.last_page//最后一页
              Indicator.close()
              if (this.pagiNation.current_page == this.pagiNation.last_page) {
                this.allLoaded = true
                MessageBox('提示', "没有更多数据了")
              }
            })
          }, 1000)
        }
        if (this.pagiNation.current_page == this.pagiNation.last_page) {
          MessageBox('提示', "没有更多数据了")
        }
      },

      getData () {//获取数据
        this.allLoaded = false
        Indicator.open({
          text: '加载中...',
          spinnerType: 'fading-circle'
        })
        this.$http.getSharkRank(this.searchData).then(res => {
          if (res.errCode == 0) {
            this.listData = res.data.list//列表数据
            this.myData = res.data.me//我的列表
            this.pagiNation.current_page = res.data.pagination.current_page//当前页面
            this.pagiNation.last_page = res.data.pagination.last_page//最后一页
            Indicator.close()
          } else {
            MessageBox('提示', res.errMsg)
          }
        })
      },
      changeData () {
        this.getData()
      },
      changeState (num) {
        this.PopupVisible = true
        this.isShow = num
        this.popupVisible = true;
      },
      getIndex (index) {
        this.currentIndex = index
      },
      onVisitChange (event) {//访客修改
        this.visitName = event.values['0'].name//名字
        this.searchData.sort = event.values['0'].id
      },
      onDateChange (event) {//修改时间
        this.dateName = event.values['0'].name
        this.searchData.day = event.values['0'].id
      },
      cancelBtn () {//取消
        this.PopupVisible = false
      },
      confirmBtn () {//确定
        this.PopupVisible = false
        this.finalVisitName = this.visitName
        this.finalDateName = this.dateName
        this.getData()//刷新
      },
      getAvatar (file) {//获取头像地址
        return `${file}`
      },
      getDetail (uid, name, phone, avatar, bc_login_token) {//详情钻取
        //  MessageBox('提示', "开发中，敬请期待！")
        this.$router.push({ name: 'sharedetail', query: { uuid: uid, name: name, phone: phone, avatar: avatar } })

      },
    },
    mounted () {
      this.getData()
    }
  }
</script>
<style scoped>
  .container {
    width: 100%;
    height: 100%;
  }
  .header {
    width: 100%;
    position: fixed;
    top: 0;
    background: #fff;
    z-index: 500;
  }
  .search-input {
    padding-left: 0.2rem;
    color: #9b9b9b;
    width: 8rem;
    height: 26px;
    line-height: 26px;
  }
  .glass {
    width: 0.5rem;
    height: 0.5rem;
    position: absolute;
    left: 8.2rem;
    top: 20%;
  }
  .title {
    font-size: 18px;
    text-align: center;
    margin: 10px 0;
  }

  .searchbox {
    padding-left: 0.2rem;
    width: 9.2rem;
    height: 28px;
    line-height: 28px;
    position: relative;
    left: 50%;
    margin-left: -4.6rem;
    background: rgba(244, 244, 244, 1);
    border-radius: 16px;
  }
  .selectbox {
    padding: 0 0.8rem;
    display: flex;
    justify-content: space-between;
    background-color: #fff;
    position: relative;
    margin: 10px 0;
    font-size: 14px;
    color: #585858;
  }
  .col {
    color: #666666;
    display: inline-block;
    font-size: 20px;
    position: relative;
    top: 0.05rem;
    left: 0.2rem;
    transform: rotate(-180deg);
  }
  .active {
    border-radius: 6px;
    border: 1px solid #5483d2;
  }
  .ranklist {
    padding-top: 3.3rem;
    color: #9b9b9b;
    padding-bottom: 2rem;
  }
  .rankitem {
    height: 2rem;
    display: flex;
    justify-content: space-between;
    position: relative;
    border: none;
  }
  .rankitem:after {
    content: "";
    position: absolute;
    bottom: 0;
    background: #d8d8d8;
    width: 100%;
    height: 1px;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0;
  }
  .border {
    margin: 0.3rem;
    height: 0.7rem;
    background: #ccc;
    width: 1px;
    position: relative;
    top: 0.2rem;
  }
  .rankitem-left {
    padding-left: 0.5rem;
  }
  .rankitem-right {
    padding-right: 0.2rem;
  }
  .rankitem-left > div,
  .rankitem-right > div {
    margin-top: 0.4rem;
    float: left;
  }
  .ranks {
    width: 0.8rem;
    position: relative;
    top: 0.4rem;
    font-size: 14px;
    color: #222222;
  }
  .rank-pic {
    width: 0.7rem;
    height: 0.7rem;
    position: absolute;
    top: 0.3rem;
    left: -10px;
    z-index: 100;
  }
  .rankitem-img {
    margin: 0 0.2rem 0 0.15rem;
  }
  .rankitem-user-avatar {
    width: 1.3rem;
    height: 1.35rem;
    border-radius: 50%;
  }
  .rankitem-name {
    font-size: 14px;
    color: #222222;
    margin-bottom: 5px;
    width: 3rem;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  .rank-num {
    font-size: 14px;
    margin-top: 6px;
    color: #585858;
    text-align: center;
  }
  .footer {
    width: 100%;
    height: 1.25rem;
    font-size: 0;
  }
  .footer span {
    width: 50%;
    height: 1.125rem;
    font-size: 0.5rem;
    line-height: 1.25rem;
    display: inline-block;
    text-align: center;
  }
  .confirm {
    color: #5483d2;
  }
</style>



// WEBPACK FOOTER //
// src/components/shareRank.vue